export default __webpack_public_path__ + "static/media/User_Manual.87d54619.pdf";